const color = (
  fieldName: string,
  label: string,
  defaultValue: string,
  extra: Record<string, unknown> = {},
) => ({
  fieldName,
  label,
  value: defaultValue,
  valueType: "string",
  filedType: "COLOR",
  placeholder: defaultValue,
  required: false,
  defaultValue,
  ...extra,
});

const toggle = (
  fieldName: string,
  label: string,
  placeholder: string,
  defaultValue: boolean,
  extra: Record<string, unknown> = {},
) => ({
  fieldName,
  label,
  value: defaultValue,
  valueType: "boolean",
  filedType: "TOGGLE",
  placeholder,
  required: false,
  defaultValue,
  ...extra,
});

/**
 * Author Byline 1 (section 3004 / variant 3000).
 *
 * There are NO content fields on purpose: the name comes from the author linked to
 * the blog page, and the meta line from the page itself (last updated date, plus
 * the optional Read Time and Views set in the page settings). Only presentation
 * and which share links appear are stored here.
 */
export const AUTHOR_BYLINE_1_CONSTANTS = {
  AUTHOR_BYLINE_FIELDS_CONFIG: [
    {
      // TEXT_BLOCK is display-only and never persisted — it renders in bold so the
      // rendering rule is impossible to miss while configuring the widget.
      fieldName: "render_rule_note",
      label: "Where this widget appears",
      filedType: "TEXT_BLOCK",
      description:
        "This widget is rendered ONLY when the page type is Blog AND an author is linked to the page. On any other page, or on a blog with no author linked, it renders nothing. Link the author in the page settings (Link Author). The name comes from that author; the meta line uses the page's last-updated date plus the Read Time and Views set in the page settings — either of those left blank is simply left out.",
      fullWidth: true,
    },

    color("background_color", "Background Color", "transparent"),
    color("byline_text_color", "Byline Text Color", "#000000"),
    color("meta_text_color", "Meta Line Text Color", "rgba(0,0,0,0.6)"),

    toggle(
      "show_author_link",
      "Link Author Name To Profile",
      "Off shows the name as plain text. The link uses the author's profile page path, or '#' when they have none",
      true,
    ),

    // ── Share links (shown on desktop and mobile) ────────────────────────────
    toggle(
      "show_share",
      "Show Share Links",
      "Master switch for the whole Share row. Links always point at the live page URL",
      true,
    ),
    toggle("show_copy_link", "Show Copy Link", "Copies the page URL", true, {
      dependsOn: "show_share",
    }),
    toggle("show_whatsapp", "Show WhatsApp", "Shares the page on WhatsApp", true, {
      dependsOn: "show_share",
    }),
    toggle("show_linkedin", "Show LinkedIn", "Shares the page on LinkedIn", true, {
      dependsOn: "show_share",
    }),
    color("share_label_color", "Share Label & Icon Color", "#000000", {
      dependsOn: "show_share",
    }),
    color("share_icon_background_color", "Share Icon Background", "#FFFFFF", {
      dependsOn: "show_share",
    }),

    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [],
};
